import _ from 'lodash';

interface ArrayDifferenceProps<T> {
  newArray: T[];
  oldArray: T[];
}

export const getArrayDifference = <T>({ newArray, oldArray }: ArrayDifferenceProps<T>): T[] => {
  return _.differenceWith(newArray, oldArray, _.isEqual);
};
